/** PostHog / product flag key — must match dashboard */
export const AUTO_LESSON_ANALYSIS_FEATURE_FLAG = 'auto_lesson_analysis';

/**
 * Which of the three auto analysis switches the student saw or used. Sent with
 * every auto analysis event so the course-page control and the two checkout
 * controls can be compared separately.
 */
export type TAutoAnalysisSurface =
  | 'course_page'
  | 'checkout_one_time'
  | 'checkout_monthly';
